"use client";

import { m as motion } from "framer-motion";
import type { ReactNode } from "react";

// Sezione "In breve" riusabile: riassunto chiaro con parole chiave evidenziate in ciano.
// Stessa struttura usata nelle pagine servizio. Da usare su tutte le pagine TRANNE la home.

const HL_PHRASES = [
  "di tua proprietà",
  "il codice è tuo",
  "codice è tuo",
  "codice resta tuo",
  "codice tuo",
  "un solo referente",
  "un unico referente",
  "prezzo deciso prima",
  "senza sorprese",
  "niente sorprese",
  "senza commissioni",
  "nessun lock-in",
  "nessun vincolo",
  "in locale",
  "gratis",
  "senza limiti",
  "su misura",
  "in autonomia",
  "tempi chiari",
  "iPhone e Android",
  "su Google",
  "prima versione",
  "i tuoi dati al sicuro",
  "una richiesta alla volta",
  "coda illimitata",
  "quota fissa",
  "ogni settimana",
];

function highlight(text: string): ReactNode {
  const price = "(?:€\\s?\\d[\\d.]*|\\d[\\d.]*\\s?(?:euro|€))";
  const phrases = HL_PHRASES.map((p) => p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const re = new RegExp(`(${price}|${phrases})`, "gi");
  const test = new RegExp(`^(?:${price}|${phrases})$`, "i");
  return text.split(re).map((part, i) =>
    part && test.test(part) ? (
      <span key={i} className="font-medium text-primary">
        {part}
      </span>
    ) : (
      part
    )
  );
}

export function InBreve({
  text,
  title = "In breve",
  className = "",
  aside,
}: {
  text: string;
  title?: string;
  className?: string;
  /** Se presente, la card diventa a tutta larghezza con un companion a destra. */
  aside?: ReactNode;
}) {
  const body = (
    <>
      <span className="font-mono text-label text-primary mb-3 block">{title}</span>
      <p className="text-body md:text-body-lg leading-relaxed text-foreground/90">
        {highlight(text)}
      </p>
    </>
  );
  return (
    <section className={`section-padding pt-8 md:pt-10 ${className}`}>
      <div className="container-wide">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className={`surface-card p-6 md:p-8 xl:p-10 ${aside ? "" : "max-w-4xl"}`}
        >
          {aside ? (
            <div className="grid items-center gap-8 xl:grid-cols-[1.5fr_0.9fr]">
              <div>{body}</div>
              <div className="flex items-center justify-center">{aside}</div>
            </div>
          ) : (
            body
          )}
        </motion.div>
      </div>
    </section>
  );
}
